import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import React, { FC } from "react";

import { OutlinedButton } from "@/features/common/components/button/OutlinedButton";
import TextPlaceholder from "@/features/placeholder/TextPlaceholder";

const BuyNowButton = dynamic(() => import("./Eth721BuyNowButton"), {
  ssr: false,
});
const ListButton = dynamic(() => import("./Eth721ListButton"), { ssr: false });

const Eth721ActionButton: FC<{
  tokenId: string;
  loadingAsset: boolean;
  listStatus: boolean;
  fullWidth?: boolean;
  isNFTOwner: boolean;
  logEventSource?: "image-card" | "post-content";
}> = (props) => {
  // For i18n translation
  const { t } = useTranslation(["common", "post"]);

  const {
    isNFTOwner,
    fullWidth = false,
    tokenId,
    loadingAsset,
    listStatus,
    logEventSource,
  } = props;

  // if no asset yet --> return loading skeleton
  if (loadingAsset) {
    <div className={fullWidth ? "w-full" : "min-w-150"}>
      <TextPlaceholder size="lg" />
    </div>;
  }

  // if current user is the owner of focal nft
  if (isNFTOwner) {
    // if the asset is listed --> owner can redirect to his/her collectible page
    if (listStatus) {
      return (
        <OutlinedButton
          fullWidth={fullWidth}
          variant="secondary"
          buttonProps={{
            disabled: true,
          }}
        >
          {t("common:nft.myCollectible")}
        </OutlinedButton>
      );
    }
    // if not listed yet, can put on sale
    return (
      <ListButton
        tokenId={tokenId}
        fullWidth={fullWidth}
        logEventSource={logEventSource}
      />
    );
  }

  // is current user does not own the focal nft and the nft is not listed --> display nothing
  if (!listStatus) {
    return null;
  }

  return (
    <BuyNowButton
      tokenId={tokenId}
      fullWidth={fullWidth}
      logEventSource={logEventSource}
    />
  );
};

export default Eth721ActionButton;
